
import { ref } from "@vue/reactivity";
import { useRouter } from "vue-router";
export default {
  setup() {
    const tabs: any = ref<any>([
      {
        lable: "首页",
        router: "/",
        children: [
          {
            lable: "监测渠道",
            router: "/",
            scrollTop: 620,
          },
          {
            lable: "数据维度",
            router: "/",
            scrollTop: 1244,
          },
          {
            lable: "报告时间",
            router: "/",
            scrollTop: 1868,
          },
          {
            lable: "市场追踪",
            router: "/",
            scrollTop: 2458,
          },
          {
            lable: "网购市场概览",
            router: "/",
            scrollTop: 3306,
          },
        ],
      },
      // {
      //   lable: "免费报告",
      //   router: "/report",
      //   children: [
      //     {
      //       lable: "数据报告",
      //       router: "/report",
      //       scrollTop: 289,
      //     },
      //   ],
      // },
      {
        lable: "联系我们",
        router: "/connect",
        children: [
          {
            lable: "填写信息",
            router: "/connect",
            scrollTop: 289,
          },
        ],
      },
      {
        lable: "加入我们",
        router: "/join",
        children: [
          {
            lable: "岗位招聘",
            router: "/join",
            scrollTop: 289,
          },
        ],
      },
      {
        lable: "关于我们",
        router: "/about",
        children: [
          {
            lable: "思勃简介",
            router: "/about",
            scrollTop: 289,
          },
          {
            lable: "联系我们",
            router: "/about",
            scrollTop: 930,
          },
        ],
      },
    ]);
    const router = useRouter();
    const checkTab = (checkedTab: any) => {
      router.push(checkedTab.router);
      setTimeout(() => {
        if (document.documentElement) {
          document.documentElement.scrollTop = checkedTab.scrollTop || 0;
        } else {
          document.body.scrollTop = checkedTab.scrollTop || 0;
        }
      }, 100);
    };
    return {
      tabs,
      checkTab,
    };
  },
};
